import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        setError("No session ID found");
        setTimeout(() => navigate('/'), 2000);
        return;
      }

      try {
        // Exchange session_id for user data and set cookie
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(response.data);
        
        // Redirect to dashboard or intended destination
        const from = location.state?.from?.pathname || '/saved';
        navigate(from, { replace: true, state: { user: response.data } });
      } catch (err) {
        console.error("Auth error:", err);
        setError("Authentication failed. Please try again.");
        setTimeout(() => navigate('/'), 2000);
      }
    };

    processSession();
  }, [navigate, location, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-destructive mb-2">{error}</p>
            <p className="text-muted-foreground text-sm">Redirecting...</p>
          </>
        ) : (
          <>
            <div className="spinner mx-auto mb-4" />
            <p className="text-muted-foreground">Signing you in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
